module.exports = __webpack_public_path__ + "img/convergence.579b7ff4.svg";